var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEigeneRezeptur = function SvgEigeneRezeptur(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Eigene_Rezeptur_svg__Ebene_2",
    viewBox: "0 0 97.61 100.31"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Eigene_Rezeptur_svg__cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:2.3px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eigene_Rezeptur_svg__Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.73 24.83 23.06 39.65V69.3l25.67 14.82L74.41 69.3V39.65z",
    className: "Eigene_Rezeptur_svg__cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.13,
    cy: 73.45,
    r: 11.33,
    className: "Eigene_Rezeptur_svg__cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.48,
    cy: 75.4,
    r: 11.33,
    className: "Eigene_Rezeptur_svg__cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.84,
    cy: 91.62,
    r: 7.55,
    className: "Eigene_Rezeptur_svg__cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.3,
    cy: 35.67,
    r: 7.55,
    className: "Eigene_Rezeptur_svg__cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.93,
    cy: 12.48,
    r: 11.33,
    className: "Eigene_Rezeptur_svg__cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.47,
    cy: 34.74,
    r: 7.55,
    className: "Eigene_Rezeptur_svg__cls-1"
  }))));
};
export default SvgEigeneRezeptur;